// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-message-actions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(-webkit-max-content, 40px));
  grid-template-columns: repeat(auto-fit, minmax(max-content, 40px));
  grid-gap: 10px;
  gap: 10px;
  height: 0px;
  transition: height 0.3s ease 0.2s;
  overflow: visible;
  justify-content: start;
  align-items: center;
}
@media screen and (max-width: 992px) {
  .user-message-actions .ui-button[data-testid=follow-up-questions-button][data-tooltip]:not([data-tooltip=""]):after {
    left: -4px;
    transform: none;
  }
  .user-message-actions .ui-button[data-testid=follow-up-questions-button][data-tooltip]:not([data-tooltip=""]):before {
    left: 16px;
    transform: none;
  }
}
.user-message-actions.extended {
  grid-template-columns: repeat(auto-fit, minmax(-webkit-max-content, 1fr));
  grid-template-columns: repeat(auto-fit, minmax(max-content, 1fr));
}
@media screen and (max-width: 992px) {
  .user-message-actions.extended > *:last-child {
    max-width: 120px;
    grid-column: auto;
    grid-row: 1;
  }
}
@media screen and (max-height: 662px) {
  .user-message-actions.extended {
    grid-template-columns: repeat(auto-fit, minmax(30px, -webkit-max-content));
    grid-template-columns: repeat(auto-fit, minmax(30px, max-content));
  }
  .user-message-actions.extended > *:last-child {
    max-width: 120px;
  }
}
.user-message-actions::before {
  display: none;
}
.user-message-actions::after {
  display: none;
}
@media screen and (max-width: 1152px) {
  .user-message-actions {
    grid-template-columns: repeat(auto-fit, minmax(-webkit-min-content, 40px));
    grid-template-columns: repeat(auto-fit, minmax(min-content, 40px));
    gap: 6px;
  }
}
@media screen and (max-width: 1024px) {
  .user-message-actions {
    grid-template-columns: repeat(auto-fit, minmax(-webkit-min-content, 40px));
    grid-template-columns: repeat(auto-fit, minmax(min-content, 40px));
  }
}
@media screen and (max-width: 992px) {
  .user-message-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-start;
    align-items: center;
  }
}
@media screen and (max-width: 576px) {
  .user-message-actions {
    gap: 6px;
  }
}
@media screen and (max-height: 662px) {
  .user-message-actions {
    grid-template-columns: repeat(auto-fit, minmax(40px, -webkit-max-content));
    grid-template-columns: repeat(auto-fit, minmax(40px, max-content));
    gap: 8px;
    justify-content: end;
  }
}
@media screen and (max-height: 662px) and (max-width: 480px) {
  .user-message-actions {
    grid-template-columns: repeat(auto-fit, minmax(36px, -webkit-max-content));
    grid-template-columns: repeat(auto-fit, minmax(36px, max-content));
    gap: 6px;
  }
}
.user-message-actions__button {
  grid-row: 1;
}
@media screen and (max-height: 662px) {
  .user-message-actions__button:not(.extended) {
    border-radius: 50% !important;
    width: 40px !important;
    height: 40px !important;
    min-height: 40px !important;
    max-width: 40px !important;
    max-height: 40px !important;
    padding: 0 !important;
    aspect-ratio: 1;
    transition: all 0.3s ease;
  }
}
@media screen and (max-height: 662px) and (max-width: 768px) {
  .user-message-actions__button:not(.extended) {
    width: 36px !important;
    height: 36px !important;
    min-height: 36px !important;
    max-width: 36px !important;
    max-height: 36px !important;
  }
}
@media screen and (max-height: 662px) {
  .user-message-actions__button:not(.extended) .ui-button__icon {
    margin: 0 !important;
  }
  .user-message-actions__button:not(.extended) .ui-button__icon--left {
    margin-right: 0 !important;
  }
  .user-message-actions__button:not(.extended) .ui-button__icon--right {
    margin-left: 0 !important;
  }
}
@media screen and (max-width: 992px) {
  .user-message-actions__button {
    border-radius: 50% !important;
    width: 40px !important;
    height: 40px !important;
    min-height: 40px !important;
    max-width: 40px !important;
    max-height: 40px !important;
  }
  .user-message-actions__button .ui-button__icon {
    margin: 0 !important;
  }
  .user-message-actions__button .ui-button__icon--left {
    margin-right: 0 !important;
  }
  .user-message-actions__button .ui-button__icon--right {
    margin-left: 0 !important;
  }
}
@media screen and (max-height: 662px) {
  .user-message-actions .ui-button:not(.extended) .ui-button__text {
    display: none !important;
  }
}
@media screen and (max-width: 992px) {
  .user-message-actions .ui-button .ui-button__text {
    display: none !important;
  }
}
.user-message-actions .share-dropdown-wrapper {
  position: relative;
  display: inline-block;
}
.user-message-actions .share-dropdown-wrapper .ui-dropdown-menu__item {
  padding-left: 4px;
}
.user-message-actions .share-copied-message {
  position: absolute;
  top: calc(100% + 12px);
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  background-color: var(--primary-color-light-500);
  box-shadow: 1px 4px 10px 0 var(--box-shadow-primary-22);
  border-radius: 12px;
  padding: 12px 16px;
  z-index: 1000;
  animation: shareCopiedFadeIn 0.35s cubic-bezier(0.21, 1.02, 0.73, 1);
  min-width: -webkit-max-content;
  min-width: max-content;
}
.user-message-actions .share-copied-message::before {
  display: none;
}
.user-message-actions .share-copied-message__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  width: 28px;
  min-width: 28px;
  border-radius: 50%;
  background-color: var(--alert-color-2);
  margin-right: 12px;
}
.user-message-actions .share-copied-message__icon i {
  font-size: 14px;
  color: var(--primary-color-light-500);
}
.user-message-actions .share-copied-message__text {
  color: var(--primary-color-dark-700);
  font-family: var(--primary-font);
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
}
@keyframes shareCopiedFadeIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}
@media screen and (min-width: 993px) {
  .user-message-actions .expand-report-dropdown {
    min-width: 190px;
  }
}
.user-message-actions .expand-report-dropdown .ui-dropdown-button__icon {
  flex-shrink: 0;
  min-width: 24px;
}`, "",{"version":3,"sources":["webpack://./src/layouts/user/Research/components/UserMessageActions/UserMessageActions.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,0EAAA;EAAA,kEAAA;EACA,cAAA;EAAA,SAAA;EACA,WAAA;EACA,iCAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;AACF;AAGI;EACE;IACE,UAAA;IACA,eAAA;EADN;EAGI;IACE,UAAA;IACA,eAAA;EADN;AACF;AAKE;EACE,yEAAA;EAAA,iEAAA;AAHJ;AAKI;EACE;IACE,gBAAA;IACA,iBAAA;IACA,WAAA;EAHN;AACF;AAMI;EAXF;IAYI,0EAAA;IAAA,kEAAA;EAHJ;EAKI;IACE,gBAAA;EAHN;AACF;AAOE;EACE,aAAA;AALJ;AAQE;EACE,aAAA;AANJ;AASE;EApDF;IAqDI,0EAAA;IAAA,kEAAA;IACA,QAAA;EANF;AACF;AAQE;EAzDF;IA0DI,0EAAA;IAAA,kEAAA;EALF;AACF;AAQE;EA9DF;IA+DI,aAAA;IACA,eAAA;IACA,QAAA;IACA,2BAAA;IACA,mBAAA;EALF;AACF;AAOE;EAtEF;IAuEI,QAAA;EAJF;AACF;AAOE;EA3EF;IA4EI,0EAAA;IAAA,kEAAA;IACA,QAAA;IACA,oBAAA;EAJF;AACF;AAKI;EAhFJ;IAiFM,0EAAA;IAAA,kEAAA;IACA,QAAA;EAFJ;AACF;AAKE;EACE,WAAA;AAHJ;AAKM;EADF;IAEI,6BAAA;IACA,sBAAA;IACA,uBAAA;IACA,2BAAA;IACA,0BAAA;IACA,2BAAA;IACA,qBAAA;IACA,eAAA;IACA,yBAAA;EAFN;AACF;AAGQ;EAZJ;IAaM,sBAAA;IACA,uBAAA;IACA,2BAAA;IACA,0BAAA;IACA,2BAAA;EAAR;AACF;AAjBM;EAoBE;IACE,oBAAA;EAAR;EAGM;IACE,0BAAA;EADR;EAIM;IACE,yBAAA;EAFR;AACF;AAMI;EArCF;IAsCI,6BAAA;IACA,sBAAA;IACA,uBAAA;IACA,2BAAA;IACA,0BAAA;IACA,2BAAA;EAHJ;EAKI;IACE,oBAAA;EAHN;EAMI;IACE,0BAAA;EAJN;EAOI;IACE,yBAAA;EALN;AACF;AAaQ;EADF;IAEI,wBAAA;EAVR;AACF;AAcM;EADF;IAEI,wBAAA;EAXN;AACF;AAeE;EACE,kBAAA;EACA,qBAAA;AAbJ;AAeI;EACE,iBAAA;AAbN;AAiBE;EACE,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,gDAAA;EACA,uDAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,oEAAA;EACA,8BAAA;EAAA,sBAAA;AAfJ;AAkBI;EACE,aAAA;AAhBN;AAmBI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,sCAAA;EACA,kBAAA;AAjBN;AAmBM;EACE,eAAA;EACA,qCAAA;AAjBR;AAqBI;EACE,oCAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAnBN;AAuBE;EACE;IACE,UAAA;IACA,4CAAA;EArBJ;EAuBE;IACE,UAAA;IACA,yCAAA;EArBJ;AACF;AAyBI;EADF;IAEI,gBAAA;EAtBJ;AACF;AAwBI;EACE,cAAA;EACA,eAAA;AAtBN","sourcesContent":[".user-message-actions {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(max-content, 40px));\n  gap: 10px;\n  height: 0px;\n  transition: height 0.3s ease 0.2s;\n  overflow: visible;\n  justify-content: start;\n  align-items: center;\n\n  // Deep Dive tooltip - align to left edge on small screens to prevent clipping\n  .ui-button[data-testid=\"follow-up-questions-button\"][data-tooltip]:not([data-tooltip=\"\"]) {\n    @media screen and (max-width: 992px) {\n      &:after {\n        left: -4px; // Slight offset to align better avoiding extreme edge\n        transform: none;\n      }\n      &:before {\n        left: 16px; // Center arrow relative to the ~40px button\n        transform: none;\n      }\n    }\n  }\n\n  &.extended {\n    grid-template-columns: repeat(auto-fit, minmax(max-content, 1fr));\n\n    @media screen and (max-width: 992px) {\n      > *:last-child {\n        max-width: 120px;\n        grid-column: auto;\n        grid-row: 1;\n      }\n    }\n\n    @media screen and (max-height: 662px) {\n      grid-template-columns: repeat(auto-fit, minmax(30px, max-content));\n      \n      > *:last-child {\n        max-width: 120px;\n      }\n    }\n  }\n\n  &::before {\n    display: none;\n  }\n\n  &::after {\n    display: none;\n  }\n\n  @media screen and (max-width: 1152px) {\n    grid-template-columns: repeat(auto-fit, minmax(min-content, 40px));\n    gap: 6px;\n  }\n\n  @media screen and (max-width: 1024px) {\n    grid-template-columns: repeat(auto-fit, minmax(min-content, 40px));\n  }\n\n  // Mobile: switch to flexbox for better button layout\n  @media screen and (max-width: 992px) {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    justify-content: flex-start;\n    align-items: center;\n  }\n\n  @media screen and (max-width: 576px) {\n    gap: 6px;\n  }\n\n  // Mobile height: change to circle buttons grid\n  @media screen and (max-height: 662px) {\n    grid-template-columns: repeat(auto-fit, minmax(40px, max-content));\n    gap: 8px;\n    justify-content: end;\n\n    @media screen and (max-width: 480px) {\n      grid-template-columns: repeat(auto-fit, minmax(36px, max-content));\n      gap: 6px;\n    }\n  }\n\n  &__button {\n    grid-row: 1;\n    &:not(.extended) {\n      @media screen and (max-height: 662px) {\n        border-radius: 50% !important;\n        width: 40px !important;\n        height: 40px !important;\n        min-height: 40px !important;\n        max-width: 40px !important;\n        max-height: 40px !important;\n        padding: 0 !important;\n        aspect-ratio: 1;\n        transition: all 0.3s ease;\n\n        @media screen and (max-width: 768px) {\n          width: 36px !important;\n          height: 36px !important;\n          min-height: 36px !important;\n          max-width: 36px !important;\n          max-height: 36px !important;\n        }\n\n        // Center icon and remove margins\n        .ui-button__icon {\n          margin: 0 !important;\n        }\n\n        .ui-button__icon--left {\n          margin-right: 0 !important;\n        }\n\n        .ui-button__icon--right {\n          margin-left: 0 !important;\n        }\n      }\n    }\n    \n    @media screen and (max-width: 992px) {\n      border-radius: 50% !important;\n      width: 40px !important;\n      height: 40px !important;\n      min-height: 40px !important;\n      max-width: 40px !important;\n      max-height: 40px !important;\n\n      .ui-button__icon {\n        margin: 0 !important;\n      }\n\n      .ui-button__icon--left {\n        margin-right: 0 !important;\n      }\n\n      .ui-button__icon--right {\n        margin-left: 0 !important;\n      }\n    }\n  \n  }\n\n  .ui-button {\n    &:not(.extended) {\n      .ui-button__text {\n        @media screen and (max-height: 662px) {\n          display: none !important;\n        }\n      }\n    }\n    .ui-button__text {\n      @media screen and (max-width: 992px) {\n        display: none !important; \n      }\n    }\n  }\n\n  .share-dropdown-wrapper {\n    position: relative;\n    display: inline-block;\n\n    .ui-dropdown-menu__item {\n      padding-left: 4px;\n    }\n  }\n\n  .share-copied-message {\n    position: absolute;\n    top: calc(100% + 12px);\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    align-items: center;\n    background-color: var(--primary-color-light-500);\n    box-shadow: 1px 4px 10px 0 var(--box-shadow-primary-22);\n    border-radius: 12px;\n    padding: 12px 16px;\n    z-index: 1000;\n    animation: shareCopiedFadeIn 0.35s cubic-bezier(0.21, 1.02, 0.73, 1);\n    min-width: max-content; // Ensure content fits\n\n    // Remove the arrow\n    &::before {\n      display: none;\n    }\n\n    &__icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: 28px;\n      width: 28px;\n      min-width: 28px; // Prevent shrinking\n      border-radius: 50%;\n      background-color: var(--alert-color-2);\n      margin-right: 12px;\n      \n      i {\n        font-size: 14px;\n        color: var(--primary-color-light-500);\n      }\n    }\n\n    &__text {\n      color: var(--primary-color-dark-700);\n      font-family: var(--primary-font);\n      font-size: 14px;\n      font-weight: 700;\n      white-space: nowrap;\n    }\n  }\n\n  @keyframes shareCopiedFadeIn {\n    from {\n      opacity: 0;\n      transform: translateX(-50%) translateY(-4px);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(-50%) translateY(0);\n    }\n  }\n\n  .expand-report-dropdown {\n    @media screen and (min-width: 993px) {\n      min-width: 190px;\n    }\n\n    .ui-dropdown-button__icon {\n      flex-shrink: 0;\n      min-width: 24px;\n    }\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
